import { Component } from 'react';
import ReturnPortal from '../pages/portal/index';
import { IntercomControlContext } from '../contexts/IntercomContext';
import axios from 'axios';
import { getLocale } from '../helpers/localePortal';
import { withRouter } from 'react-router-dom';
class ReturnPortalWrappedContext extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderData: {},
      productData: {},
      returnSettings: {},
      brandName: undefined,
      storeUrl: undefined,
      storeShopifyUrl: undefined,
      faviconUrl: undefined,
      logoUrl: undefined,
      backgroundImageUrl: undefined,
      brandColor: undefined,
      brandColorButton: '#FFFFFF',
      brandColorButtonText: undefined,
      brandColorText: undefined,
      contactEmail: undefined,
      companyIdentifier: undefined,
      orderEmail: undefined,
      orderNumber: undefined,
      orderId: undefined,
      removeBackToStoreHeader: true,
      loadingSettings: true,
      brandFontStyle: undefined,
      brandFontSize: undefined,
      brandIncentivesColor: undefined,
      language: null,
      enableTranslation: false,
      enabledTranslations: [],
      fromShopminis: false,
      hasSetIntercom: false,
      isValidStore: false
    };
  }

  static contextType = IntercomControlContext;

  async componentDidMount() {
    try {
      const url = window.location.href;
      const urlObject = new URL(url);
      const companyIdentifier =
        urlObject.searchParams.get('identifier') ||
        urlObject.searchParams.get('c');
      const returnNumber = urlObject.searchParams.get('returnNumber');
      const fromShopminis = urlObject.searchParams.get('shopminis');
      const orderId = urlObject.searchParams.get('orderId');
      this.setState({
        fromShopminis: fromShopminis === 'true' ? true : false,
        orderId,
      });

      if (companyIdentifier) {
        const response = await axios.post('/api/visitors/settings/brand', {
          companyIdentifier,
        });
        this.setState({
          ...response.data,
        });
        const responseWithResolutionOptions = await axios.post(
          '/api/visitors/return/resolutions',
          {
            companyIdentifier,
            returnNumber,
          }
        );
        this.setState({
          ...responseWithResolutionOptions.data,
        });

        const listEnabledTranslations = response.data?.translations || [];
        const listTranslationCode =
          listEnabledTranslations.map(
            (translation) => translation.languageCode
          ) || [];
        const locale = getLocale(
          listTranslationCode,
          listEnabledTranslations.find(
            (translation) => translation.defaultLanguage
          )?.languageCode
        );
        this.setState({
          language: locale,
          enabledTranslations: listEnabledTranslations,
        });
        if (response.data.intercomChatEnabled === true && !this.state.hasSetIntercom) {
            this.context.setEnabled(true);    
            this.setState({ hasSetIntercom: true });
        }
        this.setState({
          isValidStore: true,
        })
      }else {
        //companyIdentifier not found
        this.props.history.push('/error-404')
      }
    } catch (err) {
      this.props.history.push('/error-404')
      console.log('Error while getting brand Settings', err);
    }
  }

  render() {
    if(this.state.isValidStore) {
      return <ReturnPortal {...this.state} />;
    }
    return null;
  }
}

export default withRouter(ReturnPortalWrappedContext);
